import React from "react";
import { PROFILE_STATS } from "./profile-constants";

function ProfileStatItem({ tile, stats, onClick }) {
  const value = stats[tile.valueKey];
  const inner = (
    <>
      <span className="profile-stats__label">{tile.labelText}</span>
      <span className="profile-stats__value">{value}</span>
    </>
  );
  if (tile.kind === 'link') {
    return (
      <a href={tile.href} className="profile-stats__item profile-stats__item--inline">
        {inner}
      </a>
    );
  }
  return (
    <button
      type="button"
      className="profile-stats__item profile-stats__item--inline"
      onClick={onClick}
    >
      {inner}
    </button>
  );
}

function ProfileStats({ tiles = PROFILE_STATS, stats, onOpenFollowers, onOpenFollowing }) {
  const handlers = {
    followers: onOpenFollowers,
    following: onOpenFollowing,
  };
  return (
    <div className="profile-stats" aria-label="Статистика профілю">
      {tiles.map((tile) => (
        <ProfileStatItem
          key={tile.id}
          tile={tile}
          stats={stats}
          onClick={handlers[tile.id]}
        />
      ))}
    </div>
  );
}

export default ProfileStats;
